import { IApplicationState } from '../../types/redux';

export const selectLocationId = (state: IApplicationState) => {
  return state.locationId;
};
